export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"description","content":"Hire the right developers with Codepresso’s project-based assessments. Evaluate real coding skills across AI, backend, frontend, and more — and get detailed competency reports for every candidate."},{"name":"naver-site-verification","content":"8c9ab59b0267e37f9549c295032f251a4fc2b1cb"},{"property":"og:title","content":"개발자 역량 평가 플랫폼 Codepresso: Online Coding Test"},{"property":"og:description","content":"AI, 백엔드, 프론트엔드, DevOps 등 직무 기반 온라인 코딩 테스트로 실무 역량을 검증하세요. | Role-specific online coding tests to assess real-world skills in AI, backend, and frontend roles."},{"property":"og:url","content":"https://codepresso.io"},{"property":"og:type","content":"website"},{"property":"og:image","content":"https://codepresso.io/main/og_image.png"}],"link":[{"rel":"icon","href":"/icon/favicon.ico"}],"style":[],"script":[{"innerHTML":"(function(){try{var sup=['en','es','vi','ko','ja'];var m=document.cookie.match(/(?:^|; )LANG=([^;]+)/);var l=m?decodeURIComponent(m[1]).toLowerCase().split('-')[0]:'';if(!l){var ls=navigator.languages||[navigator.language||''];for(var i=0;i<ls.length;i++){var b=(ls[i]||'').toLowerCase().split('-')[0];if(sup.indexOf(b)!==-1){l=b;break;}}}if(l&&l!=='en'&&sup.indexOf(l)!==-1){var d=document.documentElement;d.setAttribute('data-i18n-pending','');d.setAttribute('data-locale-swap','');d.style.visibility='hidden';window.__i18nSafety=setTimeout(function(){d.style.visibility='';d.removeAttribute('data-i18n-pending');window.__i18nSafety=null;},2500);}}catch(e){}})();","type":"text/javascript"},{"innerHTML":"window.global = window;","type":"text/javascript"}],"noscript":[{"innerHTML":"<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-K8BBCT2H\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>"}],"title":"Codepresso: Online Coding Test & Technical Assessment for Skill-based Hiring"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = false

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false